export function downloadBlob(blob: Blob, filename: string): void {
  if (isCypressEnvironment()) {
    return;
  }

  const url = URL.createObjectURL(blob);

  try {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 100);
  }
}

export function downloadBase64(base64: string, filename: string, mimeType = 'application/pdf'): void {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: mimeType });

  downloadBlob(blob, filename);
}

function isCypressEnvironment(): boolean {
  return typeof window !== 'undefined' && 'Cypress' in window;
}
